import LocalizedStrings from "react-localization";

export const viewMappingDetailsMetadataStrings = new LocalizedStrings({
  en: {
    id: "ID",
    type: "Type",
    date: "Date",
    campaign: "Campaign",
    domain: "Domain",
    site: "Site",
    link: "Link",
  },
  fr: {
    id: "ID",
    type: "Type",
    date: "Date",
    campaign: "Campaign",
    domain: "Domain",
    site: "Site",
    link: "Link",
  },
});
